module.exports = __webpack_public_path__ + "static/media/international.801274c2.svg";